import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'complete' } )
export class CompletePipe implements PipeTransform {

    transform( pIsCompleted: boolean ): string {
        if ( pIsCompleted != null ) {
            return pIsCompleted === true ? 'Yes' : 'No';
        }
        return ' ';
    }
}
